import './index.css';
import { jsx } from 'react/jsx-runtime';
import { memo, useCallback } from 'react';
import { Radio, Checkbox } from '@hh.ru/magritte-ui-checkbox-radio';

const Action = memo(({ id, name, singleChoice, indeterminate, selected, onChange, onKeyDown }) => {
    const handleChange = useCallback((event) => {
        onChange(id, event.target.checked);
    }, [id, onChange]);
    const inputProps = {
        checked: selected,
        onChange: handleChange,
        name,
        onKeyDown,
        'data-qa': `tree-selector-input tree-selector-input-${id}`,
    };
    return singleChoice ? jsx(Radio, { ...inputProps }) : jsx(Checkbox, { ...inputProps, indeterminate: indeterminate });
});
Action.displayName = 'TreeSelectorAction';

export { Action };
//# sourceMappingURL=Action.js.map
